import { apiSlice } from './apiSlice';

export const adminApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAdminActionLogs: builder.query({
      query: ({ page = 1, pageSize = 20, action }) => {
        const params = new URLSearchParams({ page, pageSize });
        if (action && action !== 'All') params.set('action', action);
        return { url: `/api/admin/action_logs?${params}` };
      },
      keepUnusedDataFor: 30,
      providesTags: ['AdminLog'],
    }),
    getContributors: builder.query({
      query: () => ({ url: `/api/admin/contributors` }),
      keepUnusedDataFor: 30,
      providesTags: ['Contributor'],
    }),
    getContributorSystems: builder.query({
      query: ({ contributorId }) => ({
        url: `/api/admin/contributors/${contributorId}/systems`,
      }),
      keepUnusedDataFor: 30,
      providesTags: ['Contributor'],
    }),
    getContributorSystemDrives: builder.query({
      query: ({ contributorId, systemKey }) => ({
        url: `/api/admin/contributors/${contributorId}/systems/${systemKey}/drives`,
      }),
      keepUnusedDataFor: 30,
      providesTags: ['Contributor'],
    }),
    getContributorSystemBenchmarks: builder.query({
      query: ({ contributorId, systemKey, driveModel }) => ({
        url: `/api/admin/contributors/${contributorId}/systems/${systemKey}/drives/${encodeURIComponent(driveModel)}/benchmarks`,
      }),
      keepUnusedDataFor: 30,
      providesTags: ['Contributor'],
    }),
    getSubmissionStats: builder.query({
      query: ({ range = '14', tz }) => {
        const params = new URLSearchParams({ range });
        if (tz) params.set('tz', tz);
        return { url: `/api/admin/submission_stats?${params}` };
      },
      keepUnusedDataFor: 30,
      providesTags: ['Benchmark'],
    }),
  }),
});

export const {
  useGetAdminActionLogsQuery,
  useGetContributorsQuery,
  useGetContributorSystemsQuery,
  useGetContributorSystemDrivesQuery,
  useGetContributorSystemBenchmarksQuery,
  useGetSubmissionStatsQuery,
} = adminApiSlice;
